import { render, staticRenderFns } from "./DialogProductSupplier.vue?vue&type=template&id=a6e88e52"
import script from "./DialogProductSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogProductSupplier.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports